import { TablePaginationConfig } from 'antd'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { DEFAULT_PAGE_SIZE } from '@/constants'
import type { FeedProductInterface, FormattedFeedProductType } from '@/types'

import { usePriceSegmentsStore } from './priceSegmentsStore'

interface FeedStateInterface {
  isBasicPriceVisible: boolean
  isSegmentPriceVisible: boolean
  modalProductQuantity: number
  products: FormattedFeedProductType[]
  productsLoading: boolean
  productInfoToCartPresence: { [x: string]: number }
  expandedRows: string[]
  pagination: TablePaginationConfig
  columnsKeys: string[]
  paginatedTableLoading: boolean
  totalElements: number
  setIsBasicPriceVisible: (val: boolean) => void
  setIsSegmentPriceVisible: (val: boolean) => void
  setModalProductQuantity: (quantity: number) => void
  setProducts: (products: FormattedFeedProductType[]) => void
  setProductsLoading: (productsLoading: boolean) => void
  setProductInfoToCartPresence: (productInfoToCartPresence: {
    [x: string]: number
  }) => void
  setExpandedRows: (expandedRows: string[]) => void
  setPagination: (pagination: TablePaginationConfig) => void
  setColumnsKeys: (columnsKeys: string[]) => void
  setPaginatedTableLoading: (paginatedTableLoading: boolean) => void
  setTotalElements: (total: number) => void
  setInitialFeedStore: () => void
}

const initialState = {
  isBasicPriceVisible: false,
  isSegmentPriceVisible: false,
  modalProductQuantity: 1,
  products: [],
  productsLoading: true,
  searchTerm: '',
  columnsKeys: [],
  productInfoToCartPresence: {},
  expandedRows: [],
  pagination: { current: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0 },
  paginatedTableLoading: false,
  totalElements: 0,
}

export const useFeedStore = create<FeedStateInterface>()(
  persist(
    (set) => ({
      ...initialState,
      setModalProductQuantity: (quantity: number) =>
        set({ modalProductQuantity: quantity }),
      setProducts: (products: FeedProductInterface[]) => set({ products }),
      setTotalElements: (totalElements) => set({ totalElements }),
      setProductsLoading: (productsLoading: boolean) =>
        set({ productsLoading }),
      setColumnsKeys: (columnsKeys: string[]) => set({ columnsKeys }),
      setProductInfoToCartPresence: (productInfoToCartPresence) =>
        set({ productInfoToCartPresence }),
      setExpandedRows: (expandedRows: string[]) => set({ expandedRows }),
      setPagination: (pagination: TablePaginationConfig) => set({ pagination }),
      setPaginatedTableLoading: (paginatedTableLoading: boolean) =>
        set({ paginatedTableLoading }),
      setIsBasicPriceVisible: (isBasicPriceVisible) =>
        set({ isBasicPriceVisible }),
      setIsSegmentPriceVisible: (isSegmentPriceVisible) =>
        set({ isSegmentPriceVisible }),
      setInitialFeedStore: () => {
        usePriceSegmentsStore.getState().reset()
        set({ ...initialState })
      },
    }),
    {
      name: 'feed-storage',
      partialize: (state) => ({
        isBasicPriceVisible: state.isBasicPriceVisible,
        isSegmentPriceVisible: state.isSegmentPriceVisible,
      }),
    }
  )
)
